export default __webpack_public_path__ + "static/media/triceps_push-ups_start.d7590cdc.svg";